module.exports = __webpack_public_path__ + "img/09.ecb5a88d.jpg";